import { getDate, toISOString } from "medere-ui-framework";
import { axiosInstance } from "../App";
import { HealthPatientCoverageDTO } from "../dto/HealthPatientCoverageDTO";
import { PatientRecordDTO } from "../interface/interface";

export function saveHealthPatientCoverage (coverage:HealthPatientCoverageDTO){
  return axiosInstance.post('/api/secured/healthpatientservice/saveHealthPatientCoverage',{...coverage, coveragestart:toISOString(getDate(coverage.coveragestart)), coverageend:toISOString(getDate(coverage.coverageend))}).then(res => res);
}

export function getPatientByHealthPatientServiceId(healthPatientServiceId: number): Promise<PatientRecordDTO> {
  return axiosInstance.get('/api/secured/healthpatientservice/getPatientByHealthPatientServiceId', {
    params: {
      healthPatientServiceId: healthPatientServiceId
    }
  }).then((response) => {
      return response.data;
  }).catch((error) => {
      console.error(error);
      throw error;
  });
}

export function isHospitalizationService(healthPatientServiceId: number) : Promise<boolean> {
  return axiosInstance.get('/api/secured/healthpatientservice/isHospitalizationService', {
      params: {
          healthPatientServiceId: healthPatientServiceId
      }
  })
  .then(response => {
      return response.data;
  })
  .catch(error => {
      console.error(error);
      throw error;
  });
}